import {
  checkAndInsert
} from "./TOTPBKQ7.jsx";
import {
  magicTag
} from "./ARBBQ34R.jsx";
import {
  IconAlert,
  IconCircleCheck,
  IconVolume,
  IconX
} from "./WHJJ2L4B.jsx";

// src/Toaster/Toaster.tsx
import { For, Show } from "solid-js";
import { Dynamic, Portal } from "solid-js/web";

// src/Toaster/store.ts
import { createUniqueId } from "solid-js";
import { createStore } from "solid-js/store";
var [toasts, setToasts] = createStore([]);
var remove = (id) => setToasts((prev) => prev.filter((i) => i.id !== id));
var isToastOptions = (x) => x != null && typeof x === "object" && "message" in x;
var toastFn = (...args) => {
  const [message, type] = args;
  const item = {
    id: createUniqueId(),
    type: typeof type === "string" ? type : "normal",
    timeout: 3e3,
    maxToasts: 3,
    ...isToastOptions(message) ? message : { message }
  };
  setToasts((prev) => {
    const newToasts = [...prev, item];
    return newToasts.slice(-item.maxToasts);
  });
  checkAndInsert(magicTag("toaster"), Toaster);
  setTimeout(() => remove(item.id), item.timeout);
};
var toast = new Proxy(toastFn, {
  get: (_, type) => {
    return (message, options) => toastFn({ message, type, ...options });
  }
});

// src/Toaster/Toaster.tsx
var configMap = {
  normal: { icon: IconVolume, color: "#4F79E7" },
  success: { icon: IconCircleCheck, color: "#1E967D" },
  error: { icon: IconAlert, color: "#F94874" }
};
var Toast = (props) => <li
  class="animate-toast-in relative flex items-center gap-2 overflow-hidden rounded-xl border border-[color-mix(in_srgb,var(--color)_15%,#fff)] bg-[color-mix(in_srgb,var(--color)_3%,#fff)] bg-white p-4 text-sm text-[--color] opacity-60 shadow-2xl transition last:opacity-100"
  style={{ "--color": props.color ?? configMap[props.type].color }}
>
    <Dynamic component={configMap[props.type].icon} class="size-5 opacity-90" />
    <div class="flex-1">
      <Show when={props.title != null}>
        <h4 class="mb-1 font-medium">{props.title}</h4>
      </Show>
      <Show
  when={Array.isArray(props.message) && props.message.every((item) => typeof item === "string")}
  fallback={<p class="text-sm">{props.message}</p>}
>
        <For each={props.message}>{(item) => <p class="text-sm">{item}</p>}</For>
      </Show>
    </div>
    <button type="button" class="hover-allowed:hover:text-gray-800 p-0.5 text-gray-500 transition-colors" onClick={() => remove(props.id)}>
      <IconX class="size-4" />
    </button>
    <Show when={props.showProgress}>
      <i class="animate-progress absolute bottom-0 left-0 h-0.5 bg-current" style={{ "animation-duration": `${props.timeout + 100}ms` }} />
    </Show>
  </li>;
var Toaster = () => <div id={magicTag("toaster")}>
    <Show when={toasts.length}>
      <Portal>
        <ol class="z-100 fixed inset-x-0 top-0 m-10 mx-auto flex w-96 flex-col-reverse gap-4">
          <For each={toasts}>{Toast}</For>
        </ol>
      </Portal>
    </Show>
  </div>;

export {
  toast,
  Toaster
};
